module.exports = __webpack_public_path__ + "img/xjtk.890f3f05.png";